import React from 'react';
import { Box, Text } from '@indeed/ifl-components';

interface ProgressFractionProps {
    current: number;
    total: number;
}

export const ProgressFraction: React.FunctionComponent<ProgressFractionProps> = ({
    current,
    total,
}) => (
    <Box>
        <Text as="span" sx={{ fontWeight: 'bold' }}>
            {current}
        </Text>
        <Text as="span">/{total}</Text>
    </Box>
);

export default ProgressFraction;
